import { render, staticRenderFns } from "./HistoryStatus.vue?vue&type=template&id=af6abbee"
import script from "./HistoryStatus.vue?vue&type=script&lang=js"
export * from "./HistoryStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports